module.exports = __webpack_public_path__ + "static/sponsorship_img-04-a-667a9135ba0b826c49bb9b6b665d45a9.jpg";